module.exports = __webpack_public_path__ + "img/selectedContribution.24ea9d78.png";